import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

import { ProjectRegisterComponent } from './project-register.component';
import { ModalProjectRegisterSubmitComponent } from './modals/modal-project-register-submit/modal-project-register-submit.component';
import { ModalProjectRegisterFeedbackComponent } from './modals/modal-project-register-feedback/modal-project-register-feedback.component';

@NgModule({
  declarations: [
    ProjectRegisterComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    ReactiveFormsModule,
    B3DesignSystemWebModule,
    ComponentsModule,
    ModalProjectRegisterSubmitComponent,
    ModalProjectRegisterFeedbackComponent,
  ],
  exports: [
    ProjectRegisterComponent
  ],
  providers: [
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectRegisterModule { }
